var _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveAddressIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 24.5C47 42 24.5 57 24.5 57C24.5 57 2 42 2 24.5C2 18.5326 4.37053 12.8097 8.5901 8.5901C12.8097 4.37053 18.5326 2 24.5 2C30.4674 2 36.1903 4.37053 40.4099 8.5901C44.6295 12.8097 47 18.5326 47 24.5Z",
    stroke: "#1E8B7C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 32C28.6421 32 32 28.6421 32 24.5C32 20.3579 28.6421 17 24.5 17C20.3579 17 17 20.3579 17 24.5C17 28.6421 20.3579 32 24.5 32Z",
    stroke: "#1E8B7C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 44,
    r: 12,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 28.25C34.225 28.25 27.25 35.225 27.25 44C27.25 52.775 34.225 59.75 43 59.75C51.775 59.75 58.75 52.775 58.75 44C58.75 35.225 51.775 28.25 43 28.25ZM49.075 51.875L43 45.8L36.925 51.875L35.125 50.075L41.2 44L35.125 37.925L36.925 36.125L43 42.2L49.075 36.125L50.875 37.925L44.8 44L50.875 50.075L49.075 51.875Z",
    fill: "#1E8B7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveAddressIcon);
export default __webpack_public_path__ + "static/media/remove-address-icon.617c4d55.svg";
export { ForwardRef as ReactComponent };